"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "onChange"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Input/index.js";
var defaultProps = {};
function Input(_ref) {
  var className = _ref.className,
    onChange = _ref.onChange,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  function onInput(e) {
    var value = e.target.value;
    onChange(value);
  }
  return /*#__PURE__*/_react["default"].createElement("input", Object.assign({
    className: (0, _classNames["default"])('form-control', className),
    onInput: onInput
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }));
}
Input.defaultProps = defaultProps;
var _default = Input;
exports["default"] = _default;